export const getApiBaseUrl = () => {
    if (typeof window === 'undefined' || !window.location?.origin) {
        return '/api';
    }

    const origin = window.location.origin;
    if (origin.includes('localhost') || origin.includes('127.0.0.1') || origin.includes('0.0.0.0')) {
        return 'http://localhost:8000/api';
    }

    return `${origin}/api`;
};